import React from "react";
import { ReactElement } from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";

import "./dashboardStatCard.scss";

interface Props<TypeStatCard> {
  title?: string;
  stats: number | string;
  icon: string;
  iconColor?: string;
  iconBg?: string;
  label?: string;
  onClick?: () => void;
  classes?: string;
}

export default function DashboardStatCard<TypeStatCard>({
  title,
  stats,
  icon,
  iconColor,
  iconBg,
  label,
  onClick,
  classes
}: Props<TypeStatCard>): ReactElement {
  return (
    <Card
      className={`card-stats mb-4 mb-xl-0 shadow-sm ${!!onClick ? "hover pointer" : ""} ${classes && classes}`}
    >
      <CardBody
        onClick={() => {
          onClick && onClick();
        }}
      >
        <div className="d-flex justify-content-center align-items-center">
          <div
            className={`rounded-circle shadow mr-2 ${iconColor || ""}`}
            style={{ backgroundColor: iconBg, fontSize: 24 }}
          >
            <i className={icon} />
          </div>
          <div className="font-weight-bold mb-0" style={{ fontSize: 24 }}>
            {stats || "-"}
          </div>
        </div>
        <p className="mb-0 text-muted small font-weight-bold text-center">
          <span>{title}</span>
        </p>
      </CardBody>
    </Card>
  );
}
